module.exports = __webpack_public_path__ + "img/interact-stu-ready_new.4ffdfdb8.png";